import { put, delay, takeLatest } from "@redux-saga/core/effects";
import { fetchTaskById, fetchAllTasks, createTask, updateTaskStatus } from "../../../Utils/BackendAPICalls";
import { Actions, Types } from "../../Reducer/rootReducer";
import { ToDo } from "../../../Types/UnitFeatureTypes";

interface FetchToDoAction {
    payload: {
        id?: string;
        offset?: number;
        sortColumn?: string;
        sortDirection?: string;
    };
}

interface CreateToDoAction {
    payload: {
        toDoData: ToDo;
    };
}

interface UpdateTaskStatusAction {
    payload: {
        status: string;
        id: number;
    };
}

export function* fetchToDosRequestFunction(action: FetchToDoAction): Generator<any, void, Response> {
    const { id, offset, sortColumn, sortDirection } = action.payload;
    let response: any = null;
    try {
        yield delay(100);
        if (id) {
            response = yield fetchTaskById(id);
        } else {
            response = yield fetchAllTasks(sortColumn || 'created_on', sortDirection || 'desc', offset ?? 0);
        }
        if (!response || response?.error) {
            yield put(Actions.fetchToDo.toDoActions.failure({ message: response.error }));
        } else {
            yield put(Actions.fetchToDo.toDoActions.success({ tasks: response.tasks, task: response.task, count: response.count }));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchToDo.toDoActions.failure(error));
    }
}

export function* createTaskRequestFunction(action: CreateToDoAction): Generator<any, void, Response> {
    const { toDoData } = action.payload;
    try {
        yield delay(100);
        const response: any = yield createTask(toDoData);
        if (!response || response?.error) {
            yield put(Actions.todo.createTaskRequestAction.failure({ message: response.error }));
        } else {
            yield put(Actions.todo.createTaskRequestAction.success({success: response.success}));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.todo.createTaskRequestAction.failure(error));
    }
}

export function* updateTaskStatusRequestFunction(action: UpdateTaskStatusAction): Generator<any, void, Response> {
    const { status, id } = action.payload;
    try {
        yield delay(100);
        const response: any = yield updateTaskStatus(id, status);
        if (!response || response?.error) {
            yield put(Actions.todo.updateTaskStatusRequestAction.failure({ message: response.error }));
        }
        else {
            yield put(Actions.todo.updateTaskStatusRequestAction.success({success: response.success}));
        }
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.todo.updateTaskStatusRequestAction.failure(error));
    }
}

export default function* announcementSaga() {
    yield takeLatest(Types.UPDATE_TASK_STATUS_REQUEST, updateTaskStatusRequestFunction);
    yield takeLatest(Types.CREATE_TASK_REQUEST, createTaskRequestFunction);
    yield takeLatest(Types.FETCH_TODO_REQUEST, fetchToDosRequestFunction);
}
